import { ApiProperty } from "@nestjs/swagger";

 export class ActivateUserRolesDto{
    @ApiProperty()
    id:string;
 }